export const PROJECT_KEY = 'Project';
export const PROJECTS_PATH = '/projects';
